import { configureStore } from '@reduxjs/toolkit'
import  authSlice  from '../components/Redux/authSlice'
import commonApiSlice from '../components/Redux/commonApiSlice'

export const store = configureStore({
    reducer: {
        authData: authSlice,
        commonApi: commonApiSlice,
    }
}) 